import { cn } from '@/lib/utils';

/**
 * ThriveHRM wordmark. `tone="on-brand"` is the top-band version (DESIGN_SYSTEM §5): a gold tile
 * with dark ink and the name in white, display face 700.
 */
export function Logo({
  compact = false,
  tone = 'default',
  className,
  nameClassName,
}: {
  compact?: boolean;
  tone?: 'default' | 'on-brand';
  className?: string;
  /** Extra classes for the name, e.g. `max-sm:sr-only` to show the tile only on phones. */
  nameClassName?: string;
}) {
  const onBrand = tone === 'on-brand';
  return (
    <span
      data-slot="logo"
      data-tone={tone}
      className={cn(
        'flex items-center gap-2.5 font-display',
        'text-h3',
        onBrand ? 'font-bold text-on-brand' : 'text-foreground',
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'flex shrink-0 items-center justify-center rounded-md font-sans font-semibold',
          onBrand
            ? 'size-8.5 bg-accent-gold text-section text-on-accent'
            : 'size-8 bg-primary text-small text-primary-foreground',
        )}
      >
        T
      </span>
      <span className={cn(compact && 'sr-only', nameClassName)}>ThriveHRM</span>
    </span>
  );
}
